import { useMutation, useQueryClient } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export const deleteTicket = async (id: number) => {
    try {
        const response = await Axios.delete(`/tickets/${id}/`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useDeleteTicket = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteTicket,
        onSuccess: () => {
            // Invalidate and refetch tickets query to update the list
            queryClient.invalidateQueries({ queryKey: ["get-tickets"] });
        },
    });
};